import EmbedMain from './container';

export default EmbedMain;



// WEBPACK FOOTER //
// ./src/routes/Embed/Main/index.js